import { Component } from "@angular/core";

import { NavController, LoadingController } from "ionic-angular";

//import { TabsPage } from '../tabs/tabs';
import { SignupPage } from "../signup/signup";
import { ConfirmPage } from "../confirm/confirm";

import { User } from "../../providers/providers";
//import { WhiskyDB } from "../../data/db";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { Events } from "ionic-angular/util/events";
import { NavParams } from "ionic-angular/navigation/nav-params";
import { ResetPage } from "../reset/reset";

export class LoginDetails {
  email: string;
  password: string;
}

@Component({
  selector: "page-login",
  templateUrl: "login.html"
})
export class LoginPage {
  error: any;
  public loginDetails: LoginDetails;

  parent: any;

  constructor(
    public navCtrl: NavController,
    public user: User,
    public loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private viewCtrl: ViewController,
    private events: Events,
    private navParams: NavParams
  ) {
    this.loginDetails = new LoginDetails();
    this.parent = this.navParams.get("contactsPage");
  }


  login() {
    let loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loading.present();

    let details = this.loginDetails;
    console.log("login..");
    this.user
      .login(details.email, details.password)
      .then(result => {
        loading.dismiss();
        //WhiskyDB.db.setUser(this.user);
        if(this.parent != null)
        {
          this.parent.user = this.user;
          this.parent.checkAuth();
        }
        
        console.log("Sending login:done");
        this.events.publish("login:done", null);
        this.viewCtrl.dismiss();
      })
      .catch(err => {
        if (err.message === "User is not confirmed.") {
          loading.dismiss();
          this.navCtrl.push(ConfirmPage, { email: details.email });
        }
        console.log("errrror", err);
        this.error = err;
        loading.dismiss();
      });
  }

  signup() {
    let modal = this.modalCtrl.create(SignupPage);
    modal.present();
  }

  forgot() {
    let modal = this.modalCtrl.create(ResetPage);
    modal.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts